import request from '../utils/request';

export function getQueInit (){
    return request({
        url: "/wxmanager/que/queInit",
        method:'post',
    });
}
export function postUserResInfo (data){
    return request({
        url: "/wxmanager/que/saveUserResInfo",
        method:'post',
        data,
    });
}
export function postUserResPre (data){
    return request({
        url: "/wxmanager/que/userResPre",
        method:'post',
        data,
    });
}
export function getChMedInit (){
    return request({
        url: "/wxmanager/que/chMedInit",
        method:'post',
    });
}
export function postUserChPhysDec(data){
    return request({
        url: "/wxmanager/que/saveUserChPhysDec",
        method:'post',
        data,
    });
}
export function postUserChPhysDecPre (data){
    return request({
        url: "/wxmanager/que/userChPhysDecPre",
        method:'post',
        data,
    });
}
export function postUserChMedRisk (){
    return request({
        url: "/wxmanager/risk/userChMedRisk",
        method:'post',
    });
}
export function postUserRiskInfo (data){
    return request({
        url: "/wxmanager/que/saveUserRiskInfo",
        method:'post',
        data,
    });
}
export function getUserRiskInfo(){
    return request({
        url: "/wxmanager/que/getUserRiskInfo",
        method:'post',
    });
}      